import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a962aa1c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" team ")
const _hoisted_2 = { class: "flex mx-cell my-half-cell mention border-b border-charcoal mt-20 directory-heading" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow p-mention" }, "workspace", -1))
const _hoisted_4 = { class: "overflow-auto scrollbar-sm flex-1 pb-85" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WorkspaceHeading = _resolveComponent("WorkspaceHeading")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_PageItem = _resolveComponent("PageItem")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex flex-col items-stretch h-screen overflow-hidden bg-off-white navbar-animation", { 'hide-navbar': _ctx._hideNavbar }])
  }, [
    _createVNode(_component_WorkspaceHeading, { class: "h-navbar mb-20" }),
    _createElementVNode("div", {
      class: "px-cell clickable flex gap-mention py-half-cell mention",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openTeamHelper && _ctx.openTeamHelper(...args)))
    }, [
      _createVNode(_component_Icon, {
        icon: ['fal', 'users'],
        class: "icon-base"
      }),
      _hoisted_1
    ]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_Icon, {
        icon: ['fal', 'plus-square'],
        class: "icon-base clickable p-mention fade-transition add-icon",
        onClick: _ctx.createPage
      }, null, 8, ["onClick"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx._pages, (page) => {
        return (_openBlock(), _createBlock(_component_PageItem, {
          key: page,
          page: page
        }, null, 8, ["page"]))
      }), 128))
    ])
  ], 2))
}